import React from 'react';
import { TrendingUp, BookOpen, CheckCircle2, Users, Video, Lock } from 'lucide-react';
import { mockData } from '../mock';

const ServicesSection = () => {
  const iconMap = {
    TrendingUp: TrendingUp,
    BookOpen: BookOpen,
    Users: Users
  };

  return (
    <section id="services" style={{ padding: '5rem 1.5rem', background: 'var(--bg-page)' }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h2 className="heading-2" style={{ marginBottom: '1rem' }}>
            Our Tuition Services
          </h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto' }}>
            Choose the tier that matches your target grades and learning needs
          </p>
        </div>

        {/* Zoom Information Box */}
        <div style={{
          maxWidth: '800px',
          margin: '0 auto 3rem',
          padding: '1.5rem',
          background: 'linear-gradient(135deg, rgba(45, 140, 255, 0.1) 0%, rgba(45, 140, 255, 0.15) 100%)',
          border: '2px solid #2D8CFF',
          borderRadius: '12px',
          display: 'flex',
          alignItems: 'center',
          gap: '1.25rem',
          flexWrap: 'wrap'
        }}>
          <div style={{
            width: '60px',
            height: '60px',
            borderRadius: '12px',
            background: '#2D8CFF',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }}>
            <Video size={32} color="white" />
          </div>
          <div style={{ flex: 1, minWidth: '250px' }}>
            <h4 style={{ 
              fontSize: '1.1rem', 
              fontWeight: 700, 
              color: '#1a73e8',
              marginBottom: '0.5rem',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}>
              <span>All Lessons via Zoom</span>
              <Lock size={16} />
            </h4>
            <p className="body-medium" style={{ color: 'var(--text-body)', margin: 0 }}>
              All lessons take place on <strong>Zoom</strong>. Upon signing up, your child will receive a <strong>personal password</strong> to access Dr. Michael Omakobia's private meeting room for secure, interactive learning sessions.
            </p>
          </div>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '2rem',
          maxWidth: '1000px',
          margin: '0 auto'
        }}>
          {mockData.services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div key={service.id} className="product-card" style={{ height: '100%' }}>
                <div style={{
                  width: '56px',
                  height: '56px',
                  borderRadius: '12px',
                  background: 'var(--accent-wash)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '1.5rem'
                }}>
                  <IconComponent size={28} color="var(--accent-text)" />
                </div>
                
                <h3 className="heading-3" style={{ marginBottom: '1rem' }}>
                  {service.tier}
                </h3>
                
                <p className="body-medium" style={{ color: 'var(--text-secondary)', marginBottom: '1.5rem' }}>
                  {service.description}
                </p>
                
                <div style={{ marginTop: 'auto' }}>
                  <h4 style={{ fontSize: '0.875rem', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '0.75rem' }}>
                    What's Included:
                  </h4>
                  <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                    {service.features.map((feature, index) => (
                      <li key={index} style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.5rem', alignItems: 'flex-start' }}>
                        <CheckCircle2 size={18} color="var(--accent-text)" style={{ flexShrink: 0, marginTop: '2px' }} />
                        <span className="body-small">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
